export default __webpack_public_path__ + "static/media/museu-automovel.ffe22c32.jpeg";